import axios from '../axios'
import { HOME_HERO_REQUEST, HOME_HERO_SUCCESS, HOME_HERO_FAIL } from '../constants/homeConstants'

export const getHomeHero = () => async (dispatch) => {
    try {
        dispatch({ type: HOME_HERO_REQUEST })
        const { data } = await axios.get('/api/home/hero/')
        dispatch({ type: HOME_HERO_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: HOME_HERO_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
